<template>
  <v-container fluid class="pa-0">
    <v-row dense>
      <v-col cols="12" md="6">
        <Product />
      </v-col>

      <v-col cols="12" md="6">
        <Category />
      </v-col>

      <v-col cols="12">
        <CategoryStock />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CategoryStock from "../Chart/CategoryStock";
import Product from "@/modules/Product/Tile/ProductCount.vue";
import Category from "@/modules/Product/Tile/CategoryCount.vue";

export default {
  name: "inventory-home",

  components: {
    CategoryStock,
    Product,
    Category,
  },

  created() {
    document.title = "smplsale - Inventory";
  },
};
</script>

<style scoped>
.inventory-home-page {
  background: #f8fafc;
}
</style>